'use client';

import Link from 'next/link';
import {useSession} from 'next-auth/react';

export function HeaderBanner() {
	const {data: session, status} = useSession();

	if (status === 'loading') {
		return null;
	}

	return (
		<div className="bg-primary px-5 py-1.5 text-center text-sm text-black md:py-2.5 md:text-base">
			{!session?.user ? (
				<p>
					🎁 Dopiero co wystartowaliśmy. Z tej okazji każdy użytkownik podczas
					rejestracji <strong>dostaje do portfela 5zł!</strong>
				</p>
			) : (
				<Link href="/zapros-znajomych" className="hover:underline">
					🎁 Zaproś znajomych do manaboo.gg i <strong>otrzymaj 5zł</strong> za każdego z nich!
				</Link>
			)}
		</div>
	);
}
